import React from 'react';

import './style.scss';

/**
 * ErrorMessage
 * @param {JSX} children
 */

const ErrorMessage = (props) => (
    <div className="error-message" role="alert">
        <i className="zelpicon zelpicon-issue" aria-hidden="true" />
        <span>
            {props.children}
        </span>
    </div>
);

export default ErrorMessage;
